import React from 'react';

const IntelligentFinancing = () => {
  return (
    <div className="content-section">
      <div className="container mx-auto px-4">
        <div className="glass-card rounded-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-primary mb-6 text-center">
            Intelligent Financing and Crypto
          </h1>
          <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
          
          <div className="max-w-4xl mx-auto space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed text-center mb-8">
              Vajreya Ventures pioneers cutting-edge financial solutions leveraging blockchain technology, cryptocurrency, and smart financial instruments for modern investment strategies.
            </p>

            <h2 className="text-2xl font-bold text-primary mb-4">Our Services</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Cryptocurrency Investments</h3>
                <p className="text-gray-700">
                  Strategic cryptocurrency investment opportunities with expert analysis, risk management, and portfolio diversification across digital assets.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Blockchain Solutions</h3>
                <p className="text-gray-700">
                  Innovative blockchain-based financial solutions providing transparency, security, and efficiency in transactions and asset management.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Smart Financing</h3>
                <p className="text-gray-700">
                  Intelligent financing structures utilizing modern technology and data analytics for optimal capital deployment and risk-adjusted returns.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Digital Asset Management</h3>
                <p className="text-gray-700">
                  Comprehensive management of digital assets including cryptocurrencies, tokens, and NFTs with secure custody and strategic portfolio optimization.
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-primary to-primary-dark text-white rounded-lg p-8 text-center">
              <h3 className="text-2xl font-bold mb-4">Enter the Future of Finance</h3>
              <p className="mb-6">
                Explore intelligent financing and cryptocurrency opportunities with Vajreya Ventures.
              </p>
              <a 
                href="/contact" 
                className="inline-block px-8 py-3 bg-gold text-white font-semibold rounded-lg hover:bg-gold-dark transition-colors shadow-lg"
              >
                Get Started
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntelligentFinancing;